module.exports = __webpack_public_path__ + "SuryaPrakashReddyKatta-ba9bb0ce.webp";